import { render } from "./RegMobileFooter.vue?vue&type=template&id=6a529167&scoped=true"
import script from "./RegMobileFooter.vue?vue&type=script&lang=js"
export * from "./RegMobileFooter.vue?vue&type=script&lang=js"

import "./RegMobileFooter.vue?vue&type=style&index=0&id=6a529167&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a529167"]])

export default __exports__